import { render, staticRenderFns } from "./Annunciator.vue?vue&type=template&id=b3487172&scoped=true"
import script from "./Annunciator.vue?vue&type=script&lang=js"
export * from "./Annunciator.vue?vue&type=script&lang=js"
import style0 from "./Annunciator.vue?vue&type=style&index=0&id=b3487172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3487172",
  null
  
)

export default component.exports